import React from "react";
import { useNavigate, useNavigation } from "react-router-dom";

const items = [
    {
        title: "Dashboard",
        icon: "fa-solid fa-house",
        link: "/",
    },
    {
        title: "My library",
        icon: "fa-solid fa-book",
        link: "/library",
    },
    {
        title: "Stats",
        icon: "fa-solid fa-chart-line",
        link: "/stats",
    },
    {
        title: "Browse",
        icon: "fa-solid fa-chart-line",
        link: "/browse",
    }
];

const SideBar = ({ open, setOpen }: { open: boolean, setOpen: any }) => {

    const currentPath = window.location.pathname;
    const navigate = useNavigate();

    return (
        <div className="container flex flex-col mx-auto w-screen">
            <aside className={`group/sidebar flex flex-col shrink-0 lg:w-[200px] w-[200px] mt-[50px] transition-all duration-300 ease-in-out m-0 fixed z-[98] inset-y-0 left-0 bg-[#F6FAFE] border-r border-r-dashed border-r-neutral-200 sidenav fixed-start side-nav ${open ? '' : 'left-[-400px]'}`} id="sidenav-main">

                <div className="relative pl-3 my-5 overflow-y-scroll">
                    <div className="flex flex-col w-full font-medium">
                        {items.map((item, key) => (
                            <div key={key} className="group cursor-pointer "  onClick={() => navigate(item.link)} >
                                <span className={`select-none flex items-center px-4 py-[.775rem] my-[.4rem] rounded-[.95rem] group-hover:bg-[#60637A] ${currentPath === item.link ? 'bg-[#60637A]' : 'bg-none'}`}>
                                    <p className={`flex items-center flex-grow text-[1.15rem] text-neutral-400/75 group-hover:text-white ${currentPath === item.link ? 'text-white' : 'text-dark'}`}>{item.title}</p>
                                </span>
                            </div>
                        ))}
                        
                    </div>
                </div>
            </aside>
            {/* {
                open &&  <div className={`absolute overlay left-[200px] top-0 right-0 bottom-0 bg-black opacity-30 z-[98] md:hidden`} onClick={() => setOpen(false)}></div>
            } */}

            <div
                className={` top-0 left-0 right-0 bottom-0 bg-black z-[97] md:hidden
                    transition-opacity duration-300 ease-in-out fixed
                    ${open ? 'opacity-30 pointer-events-auto' : 'opacity-0 pointer-events-none'}
                `}
                onClick={() => setOpen(false)}
            />
        </div>
    );
}

export default SideBar;